import React, { useState, useEffect } from "react";
import {
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";

export default function DropdownSelect({
  label = "Select options",
  options = [],             // [{label: "A", value: "a"}, ...]
  multiple = false,         // styrer multi/single mode
  initialSelected = multiple ? [] : "", // hvis multi = [], ellers ""
  onChange,                 // callback(selectedArray | selectedValue)
  disabled = false,         // disable hele dropdown
  isOptionDisabled,         // (value) => true/false
}) {
  const [selected, setSelected] = useState(initialSelected);

  // Sync hvis initialSelected ændrer sig udefra
  useEffect(() => {
    setSelected(initialSelected);
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSelected]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
		  disabled={disabled}
          multiple={multiple}
          value={selected}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          renderValue={(selectedValues) => {
            if (!multiple) {
              const opt = options.find((o) => o.value === selectedValues);
              return opt ? opt.label : "";
            }
            return options
              .filter((opt) => selectedValues.includes(opt.value))
              .map((opt) => opt.label)
              .join(", ");
          }}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value} disabled={disabled || (isOptionDisabled?.(opt.value) ?? false)}>
              {multiple && (
                <Checkbox checked={Array.isArray(selected) && selected.indexOf(opt.value) > -1} />
              )}
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}